import React from 'react';

import { serverSideTranslation } from '../../util/next';
import { getSpliceFloorGroundList, getPlaygroundData } from '../../api/playgroundApi';

import { getPageContent } from '../../api/pagesApi';
import { formatNumForGongyi } from '../../util/number';
import { formatIntYearMonth } from '../../util/date';
import { PGContextProvider } from '../../components/GongyiProvider/PlaygroundCtxProvider';

import Page from '../../components/Layout/Page';

import PGTopBanner from '../../modules/PGTopBanner';
import PGLastNews from '../../modules/PGLastNews';
import PGYJG from '../../modules/PGYJG';
import PGDesign from '../../modules/PGDesign';
import PGUse from '../../modules/PGUse';
import PGSpeech from '../../modules/PGSpeech';
import PGVideo from '../../modules/PGVideo';
import PGCharity from '../../modules/PGCharity';
import PGOrgan from '../../modules/PGOrgan';
import NewsFooter from '../../modules/NewsFooter';

// import PlaygroundData from '../../data/playground';
// import { PlaygroundList } from '../../data/playgroundList';
import { genShareConfig } from '../../components/Share/use-config-share';
import FloatingWindow from '../../modules/FloatingWindow';

interface Props {
  pageContentData: any;
  playGroundCountData: any;
  listData: any;
  locale: string;
  _nextI18Next: any;
}

const Playground = (props: Props) => {
  const { pageContentData, playGroundCountData, listData, locale, _nextI18Next: i18n } = props;
  const { pageContent, shareContent } = pageContentData;
  const PlaygroundListData = listData?.data || []; // PlaygroundList;

  const {
    PGTopBannerData: PGTopBannerDataFromProp,
    PGtopAmoutData: PGtopAmoutDataFromProp,
    PGLastNewsData,
    PGYJGData,
    PGDesignData,
    PGUmbrellaData,
    PGSafeData,
    PGEvnData,
    PGSpeechData,
    PGVideoData,
    PGCharityNoteData,
    PGCharityNoteCardList,
    PGReflectionData,
    PGOrganData,
    PGBrandImgList,
    PGMediaImgList,
    PGRemarkData,
    PGmodalCardLabel,
    PGModalCardTabs,
    h5jumpData,
    FloatCardData,
  } = pageContent || {};

  // 处理 Banner 中统计数据
  let PGtopAmoutData = PGtopAmoutDataFromProp;
  if (Array.isArray(PGtopAmoutDataFromProp)) {
    PGtopAmoutData = PGtopAmoutDataFromProp.map((PGtopAmoutConfigItem) => {
      const { key, defaultValue, unit: configUnit = '', ...args } = PGtopAmoutConfigItem;
      const { num, unit } = formatNumForGongyi(playGroundCountData[key] || defaultValue, { lanType: locale });
      const amount = num;
      return {
        amount: amount + unit,
        unit: configUnit,
        ...args,
      };
    });
  }

  // 处理操场数，这里直接写死吧，暂时也没有什么好的解决办法
  const playgroundCnt = formatNumForGongyi(playGroundCountData.playgroundCnt || PGTopBannerDataFromProp.amout, {
    lanType: locale,
  });
  const PGTopBannerData = {
    ...PGTopBannerDataFromProp,
    amout: playgroundCnt.num + playgroundCnt.unit,
  };
  // 处理数据来源
  const nowDate = new Date();
  const dateStr = formatIntYearMonth(
    playGroundCountData.closeYear || nowDate.getFullYear(),
    playGroundCountData.closeMonth || nowDate.getMonth() + 1,
    { locale },
  );
  const { dataSrc } = PGTopBannerData;
  const dateSymbol = '{{date}}';
  if (dataSrc?.includes(dateSymbol)) {
    PGTopBannerData.dataSrc = dataSrc.replace(dateSymbol, dateStr);
  }

  return (
    <PGContextProvider value={{ PGmodalCardLabel, PGModalCardTabs }}>
      <Page title={shareContent.shareTitle}>
        <section className="bg-[#f7f8f9] pt-10 lg:pt-20">
          {/* 顶部banner模块 */}
          <PGTopBanner PGTopBannerData={PGTopBannerData} PGtopAmoutData={PGtopAmoutData} />

          {/* 操场最新消息模块 英文版本不展示 */}

          {locale !== 'en-US' ? (
            <div className="pt-1.875r lg:px-5 lg:pt-[68px] xl:px-0">
              <PGLastNews PGLastNewsData={PGLastNewsData} PlaygroundList={PlaygroundListData} />
            </div>
          ) : null}
          {/* <div className="lg:pt-3.75r pt-1.875r">
          <PGLastNews PGLastNewsData={PGLastNewsData} PlaygroundList={PlaygroundListData} />
        </div> */}
          {/* 壹基金模块 */}
          <div className="mt-1.875r bg-[#f7f8f9] lg:mt-[100px]">
            <PGYJG PGYJGData={PGYJGData} />
          </div>
          {/* 相关设计模块 */}
          <div className="bg-[#f7f8f9] pt-1.875r lg:pt-3.125r">
            <PGDesign PGDesignData={PGDesignData} />
          </div>
          {/* 功能模块 */}
          <div className="bg-[#f7f8f9] pt-0.625r lg:px-5 lg:pt-5 xl:px-0">
            <PGUse PGUmbrellaData={PGUmbrellaData} PGSafeData={PGSafeData} PGEvnData={PGEvnData} />
          </div>
          {/* 言论模块 */}
          <div className="bg-[#f7f8f9] pt-0.625r lg:px-5 lg:pt-5 xl:px-0">
            <PGSpeech SpeechCardList={PGSpeechData} />
          </div>

          {/* 视频宣传模块 */}
          {locale !== 'en-US' ? (
            <div className="bg-[#f7f8f9] pt-1.875r lg:px-5 lg:px-5 xl:px-0">
              <PGVideo PGVideoData={PGVideoData} />
            </div>
          ) : null}
          {/* 善款记录模块 */}
          <div className="bg-[#f7f8f9] pt-1.875r lg:pt-3.125r">
            <PGCharity
              PGCharityNoteData={PGCharityNoteData}
              PGCharityNoteCardList={PGCharityNoteCardList}
              PGReflectionData={PGReflectionData}
            />
          </div>

          {/* 品牌媒体模块 */}
          <div className="bg-[#f7f8f9] pt-1.875r lg:pt-3.125r">
            <PGOrgan
              PGOrganData={PGOrganData}
              PGBrandImgList={PGBrandImgList}
              PGMediaImgList={PGMediaImgList}
              PGRemarkData={PGRemarkData}
            />
          </div>
          {/* 底部新闻模块 */}
          <div className="bg-white lg:px-5 xl:px-0">
            <NewsFooter category="csr" lanType={i18n.initialLocale} positionNo="charity_3" />
          </div>
          <FloatingWindow h5jumpData={h5jumpData} FloatCardData={FloatCardData} />
        </section>
      </Page>
    </PGContextProvider>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  // /gongyi/playgound
  const pageContentParams = {
    uri: '/gongyi/playground',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const ENV = process?.env?.NEXT_ENV || '';
  const playGroundCountData = await getPlaygroundData()
    .then((res) => {
      const { data } = res || {};
      return data || {};
    })
    .catch(() => ({}));
  // const playgroundParams = {
  //   pageSize: 6,
  //   pageNo: 1,
  //   lanType: locale,
  //   status: 'EXECUTED',
  // };
  const playgroundParams = {
    count: 3,
    playgroundType: 'PLAYGROUND',
    lanType: locale,
    status: 'EXECUTED',
  };
  // const ENV = process?.env?.NEXT_ENV || '';
  const pageContentData = await getPageContent(pageContentParams, locale);
  // const listData = await getPlaygroundListData(playgroundParams);
  const listData = await getSpliceFloorGroundList(playgroundParams);

  return {
    props: {
      lxCustom: {
        cid: 'c_donation_grq5bsft',
        locale,
        ...pageContentData?.shareContent,
      },
      ENV,
      locale,
      listData,
      pageContentData,
      playGroundCountData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['cookie', 'common'])),
    },
  };
}

export default Playground;
